import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  approvedProduct,
  createProduct,
  deleteProduct,
  getProducts,
  rejectProduct,
  updateProduct
} from "../../State/Product/Action";
import {
  Box,
  Button,
  Card,
  CardHeader,
  Menu,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography,
  Grid,
  Tooltip,
  IconButton,
  Chip,
  CardContent,
  FormControl,
  InputLabel,
  Select,
  CircularProgress,
  Table, TableHead, TableRow, TableCell, TableBody, TableContainer,
  Paper,
  Autocomplete,
  FormControlLabel,
  Checkbox
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { AddCircle, Cancel, CheckCircle, Delete, Edit, FileDownload, PictureAsPdf, Print, Visibility } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { getAllCategory } from "../../../User/State/Category/Action";
import { getVendors } from "../../State/Vendor/Action";
import { toast } from "react-toastify";
import ColorModal from "../../../Vendor/Components/AddProduct/ColorModal";
import VariantModal from "../../../Vendor/Components/AddProduct/VariantModal";
import ImageModal from "../../../Vendor/Components/AddProduct/ImageModal";
import ProductDetailsModal from "../../../Vendor/Components/AddProduct/ProductDetailsModal";
import { getAllBrand } from "../../State/Brand/Action";
import { PermissionService } from "../../../config/permissionService";
import { getSelectedExportRows } from "../../../config/exportSelection";
import ImagePopup from "../../../Common/ImagePopup";
import defaultImage from "../../../Common/productDefaultImage.png"
import ProductManageModal from './../../Components/AddProduct/ProductManageModal';

const Products = () => {
  const dispatch = useDispatch();
  const { adminProduct, publicCategory, adminVendor, brands } = useSelector((store) => store);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [productId, setProductId] = useState(null);
  const [product, setProduct] = useState(null);
  const [searchText, setSearchText] = useState("");
  // Add this state for selection
  const [selectedRowIds, setSelectedRowIds] = useState([]);

  // State for confirmation dialog
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedProductVariants, setSelectedProductVariants] = useState([]);
  const [openAddProduct, setOpenAddProduct] = useState(false);
  const [reason, setReason] = useState("");
  const [gstValue, setGstValue] = useState(0);


  const isReasonValid = reason.trim() !== "";

  // variant modal handle
  const [openVariantModal, setOpenVariantModal] = useState(false);
  const [productVariants, setProductVariants] = useState(null);
  const handleVariantOpen = (product) => { setOpenVariantModal(true); setProductVariants(product) }
  const handleVariantClose = () => { setProductVariants(null); setOpenVariantModal(false); }

  // image modal handle
  const [openImageModal, setOpenImageModal] = useState(false);
  const [productImages, setProductImages] = useState(null);
  const handleImageOpen = (product) => { setOpenImageModal(true); setProductImages(product) }
  const handleImageClose = () => { setProductImages(null); setOpenImageModal(false); }

  // color modal handle
  const [openColorModal, setOpenColorModal] = useState(false);
  const [productColors, setProductColors] = useState(null);
  const handleColorOpen = (product) => { setOpenColorModal(true); setProductColors(product) }
  const handleColorClose = () => { setProductColors(null); setOpenColorModal(false); }

  // add full product details
  const [openManageModal, setOpenManageModal] = useState(false);
  const [editData, setEditData] = useState(null);

  // view details modal handle
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [openDetails, setOpenDetails] = useState(false);
  const handleViewProduct = (product) => {
    setSelectedProduct(product);
    setOpenDetails(true);
  };
  const handleCloseDetails = () => {
    setOpenDetails(false);
    setSelectedProduct(null);
  };

  const [productData, setProductData] = useState({
    vendorId: "",
    title: "",
    description: "",
    categoryId: "",
    subCategoryId: "",
    productCategoryId: "",
    brandName: "",
    gst: "",
    returnAllowed: false,
    customizationAllowed: false, // ✅ default false
    customizationPrice: 0, // ✅ default 0
  });
  const [editingId, setEditingId] = useState(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(0);
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState(0);
  const [productToDelete, setProductToDelete] = useState(null);
  const [imageOpen, setImageOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [warningOpen, setWarningOpen] = useState(false);

  // const brandOptions = React.useMemo(() => {
  //   return Array.isArray(brands?.brands?.response)
  //     ? brands.brands.response.map((b) => b.name)
  //     : [];
  // }, [brands]);

  const brandOptions = React.useMemo(() => {
    if (!Array.isArray(brands?.brands?.response)) return [];
    return brands.brands.response
      .map((b) => b?.name)
      .filter(Boolean); // null / undefined remove
  }, [brands]);

  const safeBrandValue =
    typeof productData.brandName === "string"
      ? productData.brandName
      : "";

  // Handle Approve click
  const handleApproveClick = (variants, product) => {
    setSelectedProductVariants(variants);
    setProduct(product)
    setConfirmOpen(true);
    handleMenuClose();
  };

  const handleMarginChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    const updated = [...selectedProductVariants];
    updated[index].marginPrice = value;
    setSelectedProductVariants(updated);
  };

  const handleOfferChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    const updated = [...selectedProductVariants];
    updated[index].adminDiscountPercentage = value;
    setSelectedProductVariants(updated);
  };

  const hasMissingMarginOrDiscount = (variants) => {
    return variants.some(
      (v) =>
        v.marginPrice == null ||
        v.marginPrice === "" ||
        v.marginPrice === 0 ||
        v.adminDiscountPercentage == null ||
        v.adminDiscountPercentage === "" ||
        v.adminDiscountPercentage === 0
    );
  };

  // Confirm approval
  const handleConfirmApprove = () => {
    console.log("Approve clicked", selectedProductVariants);

    const missing = hasMissingMarginOrDiscount(selectedProductVariants);

    if (missing) {
      setWarningOpen(true);
      return;
    }

    approveProduct();
  };

  const approveProduct = () => {
    const payload = selectedProductVariants.map((v) => ({
      id: v.id,
      margin: v.marginPrice,
      discount: v.adminDiscountPercentage,
    }));

    dispatch(
      approvedProduct(product?.id, payload, setConfirmOpen, setProduct)
    );
  };

  useEffect(() => {
    dispatch(getProducts());
    dispatch(getAllCategory());
    dispatch(getVendors());
    dispatch(getAllBrand());
  }, [dispatch, openAddProduct]);

  const handleMenuClick = (event, product) => {
    setAnchorEl({ anchor: event.currentTarget, product });
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleRejectProduct = (id) => {
    setProductId(id);
    setOpenDialog(true);
    handleMenuClose();
  };

  const handleRejectSubmit = (event) => {
    event.preventDefault();
    const message = new FormData(event.currentTarget).get("message");
    dispatch(rejectProduct(productId, message, setOpenDialog));
    setProductId(null);
    setReason("")
  };

  const handleCategoryClick = (categoryId) => {
    setSelectedCategoryId(categoryId);
  };

  const handleSubCategoryClick = (subCategoryId) => {
    setSelectedSubCategoryId(subCategoryId);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "gst" && !/^\d*$/.test(value)) return;
    if (name === "customizationPrice" && !/^\d*$/.test(value)) return;
    setProductData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;

    setProductData((prev) => {
      // सिर्फ customizationAllowed पे ही customizationPrice को छेड़ना है
      if (name === "customizationAllowed") {
        return {
          ...prev,
          [name]: checked,
          customizationPrice: checked ? prev.customizationPrice || 0 : 0,
        };
      }

      // बाकी checkboxes (जैसे returnAllowed) पे सिर्फ वही value update होगी
      return {
        ...prev,
        [name]: checked,
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      productData.vendorId === "" ||
      productData.title?.trim() === "" ||
      productData.description?.trim() === "" ||
      productData.brandName?.trim() === "" ||
      productData.categoryId === "" ||
      productData.subCategoryId === "" ||
      productData.productCategoryId === ""
    ) {
      toast.error("Please fill all the fields");
      return;
    }

    if (productData.title?.length < 3 || productData.title?.length > 200) {
      toast.error("Product title should be between 3 to 200 characters");
      return;
    }

    if (
      productData.description?.length < 3 ||
      productData.description?.length > 2000
    ) {
      toast.error("Product description should be between 3 to 2000 characters");
      return;
    }

    if (
      productData.brandName?.length < 3 ||
      productData.brandName?.length > 100
    ) {
      toast.error("Product Brand Name should be between 3 to 100 characters");
      return;
    }

    // ✅ ensure customizationPrice is number (default 0 if empty)
    const payload = {
      ...productData,
      customizationPrice:
        productData.customizationAllowed && productData.customizationPrice
          ? Number(productData.customizationPrice)
          : 0,
    };

    if (editingId) {
      dispatch(updateProduct(editingId, payload, handleCancle));
    } else {
      console.log("payload product data : ", payload)
      dispatch(createProduct(payload, handleCancle));
    }
  };


  const confirmDelete = () => {
    dispatch(deleteProduct(productToDelete, setOpenDeleteDialog));
    setProductToDelete(null);
  };

  const handleDeleteClick = (id) => {
    setProductToDelete(id);
    setOpenDeleteDialog(true);
  };

  const handleUpdateClick = (item) => {
    setEditData(item);
    setOpenManageModal(true)
    // setProductData({
    //   vendorId: item.vendor.id,
    //   title: item.title,
    //   description: item.description,
    //   categoryId: item.category.id,
    //   subCategoryId: item.subCategory.id,
    //   productCategoryId: item.productCategory.id,
    //   brandName: item.brand.name,
    //   gst: item.igst,
    //   returnAllowed: item?.returnAllowed?.toLowerCase() === "yes" ? true : false,
    //   customizationAllowed: item?.customizationAllowed,
    //   customizationPrice: item?.customizationPrice
    // });
    // setGstValue(item.igst)
    // setEditingId(item.id);
    // setSelectedCategoryId(item.category.id)
    // setSelectedSubCategoryId(item.subCategory.id)
    // setOpenAddProduct(true)
  };

  const handleCancle = () => {
    setProductData({
      vendorId: "",
      title: "",
      description: "",
      categoryId: "",
      subCategoryId: "",
      productCategoryId: "",
      brandName: "",
      gst: "",
      returnAllowed: false,
      customizationAllowed: false,
      customizationPrice: 0,
    });
    setGstValue(0)
    setEditingId(null);
    setSelectedCategoryId(null)
    setSelectedSubCategoryId(null)
    setOpenAddProduct(false)
  };


  const getStatusChip = (status) => {
    let color = "default";
    if (status === "APPROVED") {
      color = "success";
    } else if (status === "PENDING") {
      color = "warning";
    } else if (status === "REJECTED") {
      color = "error";
    }
    return <Chip label={status} color={color} sx={{ fontSize: "0.7rem", height: "24px", borderRadius: "12px", fontWeight: "bold" }} />;
  };

  const productRows =
    adminProduct?.products?.response?.map((product, index) => ({
      id: product.id,
      title: product.title || "----",
      brandName: product.brand?.name || "----",
      category: `${product.category?.name || ""} - ${product.subCategory?.name || ""
        } - ${product.productCategory?.name || ""}` || "----",
      color: product.colors?.map((c) => c.color?.name).join(", "),
      sizes: [...new Set(product.variants?.map(v => v?.size?.name))].join(", ") || "----",
      images: product.images,
      vendorPrices: product.variants?.map((v) => v?.vendorPrice?.toFixed(2)).join(", ") || 0.0,
      adminPrices: product.variants?.map((v) => v?.adminPrice?.toFixed(2)).join(", ") || 0.0,
      vendorName: product.vendor?.name || "----",
      vendorEmail: product.vendor?.email || "----",
      vendorPhone: product.vendor?.phone || "----",
      adminOffers:
        product.offers
          ?.filter(o =>
            o.startDateTime &&
            o.endDateTime &&
            new Date() >= new Date(o.startDateTime) &&
            new Date() <= new Date(o.endDateTime)
          )
          ?.map(o => o.discountPercentage)
          ?.join(", ") || 0,
      cgst: product?.cgst,
      sgst: product?.sgst,
      igst: product?.igst,
      admin: product?.admin,
      status: product.productStatus,
      returnAllowed: product?.returnAllowed,
      customizationAllowed: product?.customizationAllowed ? "Yes" : "NO",
      customizationPrice: product.customizationAllowed ? product?.customizationPrice : "....",
      fullProduct: product,
      variants: product.variants
    })) || [];

  const filteredRows = productRows.filter((row) => {
    const query = searchText.toLowerCase();
    // boolean values ko human-readable banाओ ("Yes"/"No")
    const customizationAllowedText = row.customizationAllowed ? "yes" : "no";
    const returnAllowedText = row.returnAllowed ? "yes" : "no";

    // number value ko string me convert कर दो
    const customizationPriceText = row.customizationPrice?.toString() || "0";
    return (
      row.title.toLowerCase().includes(query) ||
      row.brandName.toLowerCase().includes(query) ||
      row.category.toLowerCase().includes(query) ||
      row.color.toLowerCase().includes(query) ||
      row.sizes.toLowerCase().includes(query) ||
      row.vendorName.toLowerCase().includes(query) ||
      row.vendorEmail.toLowerCase().includes(query) ||
      row.vendorPhone.toLowerCase().includes(query) ||
      row.status.toLowerCase().includes(query) ||
      customizationAllowedText.includes(query) || // ✅ "yes"/"no"
      returnAllowedText.includes(query) ||        // ✅ "yes"/"no"
      customizationPriceText.includes(query)      // ✅ price numeric search
    );
  });
  const getExportData = () => getSelectedExportRows(filteredRows, selectedRowIds);


  const handleExportCSV = () => {
    const exportRows = getExportData();
    if (!exportRows) return;
    const csvContent = exportRows.map((row, index) => {
      return [
        index + 1,
        `"${row.title}"`,
        `"${row.brandName}"`,
        `"${row.category}"`,
        `"${row.color}"`,
        `"${row.sizes}"`,
        `"${row.vendorPrices}"`,
        `"${row.adminPrices}"`,
        `"${row.adminOffers}"`,
        `"${row.igst}"`,
        `"${row.vendorName}"`,
        `"${row.vendorEmail}"`,
        `"${row.vendorPhone}"`,
        row.returnAllowed,
        row.customizationAllowed,
        row.customizationPrice,
        row.status,
      ].join(',');
    }).join('\n');

    const headers = [
      'S.No.',
      'Title',
      'Brand Name',
      'Category',
      'Colors',
      'Sizes',
      'Vendor Prices',
      'Admin Prices',
      'Admin Offers(%)',
      'GST(%)',
      'Margin',
      'Vendor Name',
      'Vendor Email',
      'Vendor Phone',
      'Return Allowed',
      'Customization Allowed',
      'Customization Price',
      'Status',
    ].join(',');

    const csv = `${headers}\n${csvContent}`;
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'products.csv';
    link.click();
  };

  const handleExportPDF = () => {
    const exportRows = getExportData();
    if (!exportRows) return;
    const doc = new jsPDF({
      orientation: "landscape", // wider layout
      unit: "pt",                // use points for precision
      format: "a3",              // bigger page to fit all columns
    });

    doc.setFontSize(14);
    doc.text("Product List", 40, 30);

    const tableColumn = [
      'S.No.',
      'Title',
      'Brand Name',
      'Category',
      'Colors',
      'Sizes',
      'Vendor Prices',
      'Admin Prices',
      'Admin Offers(%)',
      'GST(%)',
      'Margin',
      'Vendor Name',
      'Vendor Email',
      'Vendor Phone',
      'Return Allowed',
      'Customization Allowed',
      'Customization Price',
      'Status',
    ];

    const tableRows = [];

    exportRows.forEach((product, index) => {
      const productData = [
        index + 1,
        product.title,
        product.brandName,
        product.category,
        product.color,
        product.sizes,
        product.vendorPrices,
        product.adminPrices,
        product.adminOffers,
        product.igst,
        product.vendorName,
        product.vendorEmail,
        product.vendorPhone,
        product.returnAllowed,
        product.customizationAllowed,
        product.customizationPrice,
        product.status,
      ];
      tableRows.push(productData);
    });

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 40,
      theme: 'striped',
      headStyles: {
        fillColor: [37, 99, 235], // Tailwind blue-600 (RGB: 37,99,235)
        textColor: [255, 255, 255], // white text
        halign: 'left',
      },
      styles: {
        fontSize: 9,
        cellPadding: 4,
        overflow: 'linebreak',
      },
      didDrawPage: (data) => {
        doc.setFontSize(10);
        doc.text(`Generated on ${new Date().toLocaleString()}`, data.settings.margin.left, doc.internal.pageSize.height - 10);
      }
    });

    doc.save('products.pdf');
  };

  const writeAction = PermissionService.has({ category: "Admin", page: "Products", type: "WRITE" });

  const columns = [
    {
      field: "serialNo",
      headerName: "S.No.",
      width: 80,
      sortable: false,
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1
    },
    { field: "title", headerName: "Title", width: 120 },
    { field: "brandName", headerName: "Brand Name", width: 100 },
    { field: "category", headerName: "Category", width: 120 },
    { field: "vendorName", headerName: "Vendor Name", width: 100 },
    { field: "vendorEmail", headerName: "Vendor Email", width: 120 },
    { field: "vendorPhone", headerName: "Vendor Phone", width: 100 },
    {
      field: "color",
      headerName: "Color",
      width: 150,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" gap={0.5} pt={0} sx={{ padding: 0, minHeight: 0 }}>
          {/* {writeAction && (<AddCircle
            fontSize="small"
            color="primary"
            sx={{ cursor: "pointer", fontSize: 16, p: 0, m: 0 }}
            onClick={() => handleColorOpen(params.row.fullProduct)}
          />
          )} */}
          <Typography variant="body2" sx={{ fontSize: "0.8rem", p: 0, m: 0 }}>{params.value}</Typography>
        </Box>
      ),
    },
    {
      field: "sizes",
      headerName: "Sizes",
      width: 200,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" gap={0.5} pt={0} sx={{ padding: 0, minHeight: 0 }}>
          {/* {params?.row?.fullProduct?.colors?.length > 0 && writeAction && (
            <AddCircle
              fontSize="small"
              color="primary"
              sx={{ cursor: "pointer", fontSize: 16, p: 0, m: 0 }}
              onClick={() => handleVariantOpen(params.row.fullProduct)}
            />
          )} */}
          <Typography variant="body2" sx={{ fontSize: "0.8rem", p: 0, m: 0 }}>{params.value}</Typography>
        </Box>
      ),
    },
    {
      field: "images",
      headerName: "Images",
      width: 150,
      renderCell: (params) => {
        const images = params.row?.images || [];
        const primaryImages = images.filter((img) => img.isPrimary);
        const otherImages = images.filter((img) => !img.isPrimary);

        return (
          <Box display="flex" alignItems="center" gap={0.5}>
            {/* {params?.row?.fullProduct?.colors?.length > 0 && writeAction && (
              <AddCircle
                fontSize="small"
                color="primary"
                sx={{ cursor: "pointer" }}
                onClick={() => handleImageOpen(params.row.fullProduct)}
              />
            )} */}
            {/* Primary image - slightly bigger */}
            {primaryImages.map((img, index) => (
              <Box
                onClick={() => { setImageOpen(true); setImageUrl(img.fullUrl || defaultImage) }}
                key={index}
                component="img"
                src={img.fullUrl || defaultImage}
                alt={`Primary ${index + 1}`}
                sx={{
                  width: 30,
                  height: 30,
                  objectFit: "cover",
                  borderRadius: 1,
                  border: "2px solid #1976d2",
                  cursor: "pointer"
                }}
              />
            ))}

            {/* Other images - smaller */}
            {otherImages.slice(0, 2).map((img, index) => ( // Show max 2 other images
              <Box
                onClick={() => { setImageOpen(true); setImageUrl(img.fullUrl || defaultImage) }}
                key={index}
                component="img"
                src={img.fullUrl || defaultImage}
                alt={`Variant ${index + 1}`}
                sx={{
                  width: 20,
                  height: 20,
                  objectFit: "cover",
                  borderRadius: 1,
                  opacity: 0.8,
                  cursor: "pointer"
                }}
              />
            ))}
            {otherImages.length > 2 && (
              <Typography variant="body2" sx={{ fontSize: "0.7rem", ml: 0.5 }}>
                +{otherImages.length - 2}
              </Typography>
            )}
          </Box>
        );
      },
    },
    { field: "adminOffers", headerName: "Admin Offer(%)", width: 100 },
    { field: "igst", headerName: "GST", width: 100, renderCell: (params) => (params.value ? ("IGST - " + params.row.igst + "% , CGST - " + params.row.cgst + "% , SGST - " + params.row.sgst + "%") : 0) },
    { field: "vendorPrices", headerName: "Vendor Price", width: 100 },
    { field: "adminPrices", headerName: "Admin Price", width: 100 },
    { field: "returnAllowed", headerName: "Return Allowed", width: 120 },
    { field: "customizationAllowed", headerName: "Customization Allowed", width: 120 },
    { field: "customizationPrice", headerName: "Customization Price", width: 120 },
    {
      field: "status",
      headerName: "Approval Status",
      width: 120,
      renderCell: (params) => getStatusChip(params.value)
    },
    ...(writeAction ? [
      {
        field: "update",
        headerName: "Approval",
        width: 150,
        sortable: false,
        renderCell: ({ row }) => (
          <Button
            size="small"
            variant="contained"
            sx={{
              background: "linear-gradient(90deg, #592545 0%, #a63f7b 100%)",
              color: "#fff",
              fontWeight: 600,
              fontSize: "0.8rem",
              borderRadius: "6px",
              px: 1.5,
              py: 0.5,
              transition: "all 0.2s",
              "&:hover": {
                background: "linear-gradient(90deg, #a63f7b 0%, #592545 100%)",
                boxShadow: "0 4px 12px rgba(89,37,69,0.2)",
                transform: "scale(1.02)",
              },
              cursor: "pointer",
            }}
            onClick={(e) => handleMenuClick(e, row)}
            disabled={!row.variants?.length || !row.images?.length}
          >
            Approval
          </Button>
        )
      },
    ] : []),
    {
      field: "fullProduct",
      headerName: "View Details",
      width: 60,
      renderCell: (params) => (
        <IconButton
          size="small"
          color="primary"
          sx={{ p: 0, m: 0, cursor: "pointer" }}
          onClick={() => handleViewProduct(params.row.fullProduct)}
        >
          <Visibility fontSize="small" sx={{ fontSize: 18, cursor: "pointer" }} />
        </IconButton>
      ),
    },
    ...(writeAction ? [
      {
        field: "actions",
        headerName: "Action",
        width: 80,
        renderCell: (params) =>
          <Box display="flex" gap={0} sx={{ p: 0, m: 0, minHeight: 0 }}>
            <Tooltip title="Edit">
              <IconButton
                size="small"
                sx={{ p: 0, m: 0, minWidth: 24, minHeight: 24, cursor: "pointer" }}
                onClick={() => handleUpdateClick(params.row.fullProduct)}
              >
                <Edit fontSize="small" sx={{ fontSize: 15, cursor: "pointer" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton
                color="error"
                size="small"
                sx={{ p: 0, m: 0, minWidth: 24, minHeight: 24, cursor: "pointer" }}
                onClick={() => handleDeleteClick(params.row.id)}
              >
                <Delete fontSize="small" sx={{ fontSize: 15, cursor: "pointer" }} />
              </IconButton>
            </Tooltip>
          </Box>
      }
    ] : []),
  ];

  const excludedFields = ['serialNo.', 'images', 'update', 'fullProduct', 'actions']; // Add more fields if needed

  const exportableColumns = columns.filter(col => !excludedFields.includes(col.field));
  // Get headers from column definitions
  const headers = exportableColumns.map(col => col.headerName);
  const csvFields = exportableColumns.map(col => col.field);

  const handlePrint = () => {
    const exportRows = getExportData();
    if (!exportRows) return;
    const printWindow = window.open('', '_blank');
    const data = exportRows.map(row =>
      csvFields.map(field => row[field] ?? "----")
    );

    const html = `
      <html>
        <head>
          <title>Product List</title>
          <style>
            @media print {
              @page { size: A3 landscape; }
            }
            body {
              font-family: Arial, sans-serif;
              font-size: 12px;
            }
            table {
              border-collapse: collapse;
              width: 100%;
              table-layout: auto;
            }
            th, td {
              border: 1px solid #999;
              padding: 4px;
              text-align: left;
              white-space: pre-wrap;
              word-break: break-word;
            }
            th {
                background: #449AEF;
                color: white;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
              tr:nth-child(even) {
              background: #f5f5f5;
            }
          </style>
        </head>
        <body>
          <h2>Product List</h2>
          <table>
            <thead>
              <tr>${headers.map(h => `<th>${h}</th>`).join('')}</tr>
            </thead>
            <tbody>
              ${data.map(row => `<tr>${row.map(cell => `<td>${cell}</td>`).join('')}</tr>`).join('')}
            </tbody>
          </table>
        </body>
      </html>
    `;

    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.onload = () => {
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
      }, 300);
    };
  };


  return (
    <div >
      <Card sx={{ borderRadius: 2, boxShadow: 1, p: 1 }}>
        <CardHeader
          title={
            <Typography variant="h6" className="text-gray-700">
              PRODUCTS
            </Typography>
          }
          action={writeAction && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <IconButton
                sx={{
                  background: "linear-gradient(90deg, #449AEF 0%, #f87171 100%)",
                  color: "#fff",
                  boxShadow: "0 2px 8px rgba(239,68,68,0.15)",
                  transition: "all 0.2s",
                  "&:hover": {
                    background: "linear-gradient(90deg, #f87171 0%, #449AEF 100%)",
                    boxShadow: "0 4px 16px rgba(239,68,68,0.25)",
                    transform: "scale(1.02)",
                  },
                  cursor: "pointer",
                  p: 1,
                  borderRadius: '50%',
                }}
                // onClick={() => {
                //   setOpenAddProduct(true);
                //   setEditingId(null);
                // }}
                onClick={() => {
                  setOpenManageModal(true)
                  setEditData(null);
                }}
              >
                <AddIcon />
              </IconButton>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 700, color: "#449AEF", fontSize: "1.2rem", letterSpacing: 0.2 }}
              >
                Add Product
              </Typography>
            </Box>
          )}
        />
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', mb: 2 }}>
            <Box sx={{ display: 'flex', gap: 1.5, mb: { xs: 2, sm: 0 } }}>
              <Button
                variant="contained"
                startIcon={<FileDownload />}
                onClick={handleExportCSV}
                sx={{
                  background: 'linear-gradient(90deg, #592545 0%, #a63f7b 100%)',
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '0.85rem',
                  borderRadius: '6px',
                  px: 2,
                  py: 0.8,
                  transition: 'all 0.2s',
                  '&:hover': {
                    background: 'linear-gradient(90deg, #a63f7b 0%, #592545 100%)',
                    boxShadow: '0 4px 12px rgba(89,37,69,0.2)',
                    transform: 'scale(1.02)',
                  },
                  cursor: 'pointer',
                  width: { xs: '100%', sm: 'auto' },
                }}
              >
                Export CSV
              </Button>
              <Button
                variant="contained"
                startIcon={<PictureAsPdf />}
                onClick={handleExportPDF}
                sx={{
                  background: 'linear-gradient(90deg, #592545 0%, #a63f7b 100%)',
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '0.85rem',
                  borderRadius: '6px',
                  px: 2,
                  py: 0.8,
                  transition: 'all 0.2s',
                  '&:hover': {
                    background: 'linear-gradient(90deg, #a63f7b 0%, #592545 100%)',
                    boxShadow: '0 4px 12px rgba(89,37,69,0.2)',
                    transform: 'scale(1.02)',
                  },
                  cursor: 'pointer',
                  width: { xs: '100%', sm: 'auto' },
                }}
              >
                Export PDF
              </Button>
              <Button
                variant="contained"
                startIcon={<Print />}
                onClick={handlePrint}
                sx={{
                  background: 'linear-gradient(90deg, #592545 0%, #a63f7b 100%)',
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '0.85rem',
                  borderRadius: '6px',
                  px: 2,
                  py: 0.8,
                  transition: 'all 0.2s',
                  '&:hover': {
                    background: 'linear-gradient(90deg, #a63f7b 0%, #592545 100%)',
                    boxShadow: '0 4px 12px rgba(89,37,69,0.2)',
                    transform: 'scale(1.02)',
                  },
                  cursor: 'pointer',
                  width: { xs: '100%', sm: 'auto' },
                }}
              >
                Print
              </Button>
            </Box>
            <Box>
              <TextField
                label="Search Products"
                variant="outlined"
                size="small"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                sx={{ width: { xs: '100%', sm: '300px' } }}
              />
            </Box>
          </Box>
          <Box sx={{ height: "100%", width: "100%" }}>
            <DataGrid
              rows={filteredRows}
              columns={columns}
              pagination
              initialState={{
                pagination: { paginationModel: { pageSize: 10, page: 0 } },
              }}
              pageSizeOptions={[10, 25, 50, 75, 100]}
              getRowId={(row) => row.id}
              checkboxSelection
              onRowSelectionModelChange={(ids) => setSelectedRowIds(ids)}
              rowSelectionModel={selectedRowIds}
              disableSelectionOnClick
              density="compact"
              experimentalFeatures={{ virtualization: true }}
              loading={adminProduct.loading}
              autoHeight={true}
              sx={{
                borderRadius: 2,
                fontSize: "0.8rem",
                "& .MuiDataGrid-cell": {
                  fontSize: "0.8rem",
                  border: "1px solid rgb(204, 201, 201)",
                  minHeight: "36px !important",
                  height: "36px !important",
                  lineHeight: "1.2",
                  paddingTop: "4px",
                  paddingBottom: "4px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                },
                "& .MuiDataGrid-columnHeader": {
                  backgroundColor: "#449AEF",
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "0.8rem",
                  border: "1px solid rgb(204, 201, 201)",
                  minHeight: "36px !important",
                  height: "36px !important",
                  lineHeight: "1.2",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontSize: "0.8rem",
                  fontWeight: 600,
                },
                "& .MuiDataGrid-row": {
                  maxHeight: "36px !important",
                  minHeight: "36px !important",
                },


                "& .MuiDataGrid-row:nth-of-type(odd)": {
                  backgroundColor: "#f5f5f5",
                },
                "& .MuiDataGrid-row:nth-of-type(even)": {
                  backgroundColor: "#ffffff",
                },
                "& .MuiDataGrid-row:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
            />
          </Box>
        </CardContent>
      </Card>

      {/* Status Change Menu */}
      <Menu
        anchorEl={anchorEl?.anchor}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            minWidth: 180,
            borderRadius: 2,
            boxShadow: 3,
          },
        }}
      >
        {anchorEl?.product?.status === "PENDING" ? (
          <>
            <MenuItem
              onClick={() => handleApproveClick(anchorEl?.product?.variants, anchorEl?.product)}
              sx={{ color: "#2e7d32" }}
            >
              <CheckCircle fontSize="small" sx={{ mr: 1 }} />
              Approve Product
            </MenuItem>

            <MenuItem
              onClick={() => handleRejectProduct(anchorEl?.product?.id)}
              sx={{ color: "#c62828" }}
            >
              <Cancel fontSize="small" sx={{ mr: 1 }} />
              Reject Product
            </MenuItem>
          </>
        ) : (
          anchorEl?.product?.status === "APPROVED" ? (
            <MenuItem
              onClick={() => handleRejectProduct(anchorEl?.product?.id)}
              sx={{ color: "#c62828" }}
            >
              <Cancel fontSize="small" sx={{ mr: 1 }} />
              Reject Product
            </MenuItem>
          ) : (
            <MenuItem
              onClick={() => handleApproveClick(anchorEl?.product?.variants, anchorEl?.product)}
              sx={{ color: "#2e7d32" }}
            >
              <CheckCircle fontSize="small" sx={{ mr: 1 }} />
              Approve Product
            </MenuItem>
          )
        )}

      </Menu>


      {/* Approved product dialog box */}
      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: "0px 10px 30px rgba(0,0,0,0.2)",
          },
        }}
      >
        {/* Title */}
        <DialogTitle
          sx={{
            fontSize: "1.4rem",
            fontWeight: 600,
            textAlign: "center",
            backgroundColor: "#f3f4f6",
            borderBottom: "1px solid #e0e0e0",
            py: 2,
          }}
        >
          Confirm Approval
        </DialogTitle>

        {/* Content */}
        <DialogContent sx={{ backgroundColor: "#f9fafb", px: 2, py: 2 }}>
          <DialogContentText sx={{ fontSize: "0.95rem", mb: 2, textAlign: "center", }}>
            Please enter the margin price and discount percentage for this product Variants:
          </DialogContentText>
          <Typography variant="h6" gutterBottom>
            Variants
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TableContainer component={Paper} sx={{ maxHeight: 300, overflowX: "auto" }}>

                <Table size="small" stickyHeader>
                  <TableHead sx={{ backgroundColor: "#f3f4f6" }}>
                    <TableRow>
                      <TableCell><strong>Product Color</strong></TableCell>
                      <TableCell><strong>Size</strong></TableCell>
                      <TableCell><strong>Price</strong></TableCell>
                      <TableCell><strong>Discount Price</strong></TableCell>
                      <TableCell><strong>Actual Price</strong></TableCell>
                      <TableCell><strong>GST Price</strong></TableCell>
                      <TableCell><strong>Total Price</strong></TableCell>
                      <TableCell><strong>Stock</strong></TableCell>
                      <TableCell><strong>Margin</strong></TableCell>  {/* New column */}
                      <TableCell><strong>Discount (%)</strong></TableCell>   {/* New column */}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {selectedProductVariants?.map((v, index) => (
                      <TableRow key={v.id}>
                        <TableCell>{v.productColor?.color?.name}</TableCell>
                        <TableCell>{v.size?.name}</TableCell>
                        <TableCell>{v.price?.toFixed(2)}</TableCell>
                        <TableCell>{v.vendorDiscountPrice?.toFixed(2)}</TableCell>
                        <TableCell>{v.vendorActualPrice?.toFixed(2)}</TableCell>
                        <TableCell>{v.vendorIGstPrice?.toFixed(2)}</TableCell>
                        <TableCell>{v.vendorPrice?.toFixed(2)}</TableCell>
                        <TableCell>{v.stockQuantity}</TableCell>

                        {/* Margin Input */}
                        <TableCell>
                          <TextField
                            variant="outlined"
                            size="small"
                            placeholder="Enter margin"
                            value={v.marginPrice || ""}
                            onChange={(e) => handleMarginChange(index, e.target.value)}
                            fullWidth
                            inputProps={{ style: { padding: '8px', fontSize: '0.8rem' } }}
                            sx={{
                              minWidth: 80,
                            }}
                          />
                        </TableCell>

                        {/* Offer Input */}
                        <TableCell>
                          <TextField
                            variant="outlined"
                            size="small"
                            placeholder="Enter Discount"
                            value={v.adminDiscountPercentage || ""}
                            onChange={(e) => handleOfferChange(index, e.target.value)}
                            fullWidth
                            inputProps={{ maxLength: 2, style: { padding: '8px', fontSize: '0.8rem' } }}
                            sx={{
                              minWidth: 80,
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </DialogContent>

        {/* Actions */}
        <DialogActions
          sx={{
            px: 3,
            py: 2,
            backgroundColor: "#f3f4f6",
            borderTop: "1px solid #e0e0e0",
            justifyContent: "center",
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          <Button
            onClick={() => setConfirmOpen(false)}
            variant="outlined"
            color="error"
            sx={{
              px: 4,
              py: 1,
              fontWeight: 600,
              borderRadius: 2,
              "&:hover": {
                backgroundColor: "#fee2e2",
              },
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={handleConfirmApprove}
            disabled={adminProduct.loading}
            sx={{
              background: "linear-gradient(90deg, #22c55e, #16a34a)",
              color: "#fff",
              fontWeight: 600,
              borderRadius: 2,
              px: 4,
              py: 1,
              boxShadow: "0px 4px 12px rgba(34,197,94,0.2)",
              "&:hover": {
                background: "linear-gradient(90deg, #16a34a, #22c55e)",
                transform: "scale(1.02)",
              },
            }}
          >
            {adminProduct.loading ? (
              <>
                <CircularProgress size={20} sx={{ mr: 1, color: "white" }} />
                Processing...
              </>
            ) : (
              "✅ Approve"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* reject product */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ textAlign: "center", fontSize: "1.1rem", fontWeight: "bold", mt: 1, mb: 0.5, pb: 1, borderBottom: '1px solid rgba(0, 0, 0, 0.1)' }}>
          Reject Product
        </DialogTitle>
        <DialogContent sx={{ px: 3, py: 2, textAlign: "center" }}>
          <DialogContentText sx={{ mb: 2, fontSize: "0.9rem", textAlign: "center", }}>
            Please provide a reason for rejecting this product:
          </DialogContentText>
          <form onSubmit={handleRejectSubmit}>
            <TextField
              autoFocus
              margin="dense"
              id="message"
              name="message"
              label="Reason"
              type="text"
              fullWidth
              multiline
              rows={4}
              variant="outlined"
              size="small"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              sx={{ mb: 2 }}
            />
            <DialogActions sx={{ display: "flex", justifyContent: "center", gap: 2, p: 2, borderTop: '1px solid rgba(0, 0, 0, 0.1)' }}>
              <Button
                onClick={() => setOpenDialog(false)}
                variant="outlined"
                sx={{
                  color: "#449AEF",
                  borderColor: "#449AEF",
                  fontWeight: 600,
                  fontSize: "0.85rem",
                  borderRadius: "8px",
                  px: 3,
                  py: 1.2,
                  transition: "all 0.2s",
                  "&:hover": {
                    backgroundColor: "#449AEF",
                    color: "#fff",
                    borderColor: "#449AEF",
                    boxShadow: "0 2px 8px rgba(239,68,68,0.1)",
                  },
                  width: { xs: "100%", sm: "auto" },
                  textAlign: "center"
                }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                disabled={!isReasonValid || adminProduct.loading}
                sx={{
                  background: "linear-gradient(90deg, #449AEF 0%, #f87171 100%)",
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: "0.85rem",
                  borderRadius: "8px",
                  boxShadow: "0 2px 8px rgba(239,68,68,0.15)",
                  px: 3,
                  py: 1.2,
                  transition: "all 0.2s",
                  "&:hover": {
                    background: "linear-gradient(90deg, #f87171 0%, #449AEF 100%)",
                    boxShadow: "0 4px 16px rgba(239,68,68,0.25)",
                    transform: "scale(1.02)",
                  },
                  width: { xs: "100%", sm: "auto" },
                  textAlign: "center"
                }}
              >
                {adminProduct.loading ? (
                  <>
                    <CircularProgress size={20} sx={{ mr: 1 }} />
                    Processing...
                  </>
                ) : ("Reject")}
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>

      {/* Replace the form rendering with a Dialog: */}
      <Dialog
        open={openAddProduct}
        onClose={handleCancle}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: '12px',
            boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
          },
        }}
      >
        <DialogTitle sx={{ textAlign: "center", fontSize: "1.25rem", fontWeight: "bold", mt: 1, mb: 0.5, pb: 1, borderBottom: '1px solid rgba(0, 0, 0, 0.1)' }}>
          {editingId ? "UPDATE PRODUCT" : "ADD PRODUCT"}
        </DialogTitle>
        <DialogContent sx={{ px: 2, py: 1 }}>
          <Card className="mb-4" sx={{ borderRadius: 2, boxShadow: 1 }}>
            <CardContent sx={{ p: 2 }}>
              <form onSubmit={handleSubmit}>
                <Grid container spacing={1.5}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Vendor</InputLabel>
                      <Select
                        name="vendorId"
                        size="small"
                        label="Vendor"
                        disabled={editingId}
                        value={productData.vendorId}
                        onChange={handleChange}
                        sx={{
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#e5e7eb'
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#ef4444'
                          }
                        }}
                      >
                        <MenuItem value={0} disabled>Select Vendor...</MenuItem>
                        {adminVendor?.vendors?.response
                          ?.filter((v) => v?.approved && !v?.isBlocked)
                          ?.map(
                            (vendor) =>
                              vendor && (
                                <MenuItem
                                  key={vendor.id}
                                  value={vendor.id}
                                >
                                  {vendor?.name}
                                </MenuItem>
                              )
                          )}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={8}>
                    <TextField
                      fullWidth
                      label="Product Title"
                      name="title"
                      size="small"
                      value={productData.title}
                      onChange={handleChange}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: '#e5e7eb'
                          },
                          '&:hover fieldset': {
                            borderColor: '#ef4444'
                          }
                        }
                      }}
                    />
                  </Grid>


                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      multiline
                      rows={3}
                      label="Product Description"
                      size="small"
                      name="description"
                      value={productData.description}
                      onChange={handleChange}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: '#e5e7eb'
                          },
                          '&:hover fieldset': {
                            borderColor: '#ef4444'
                          }
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Category</InputLabel>
                      <Select
                        name="categoryId"
                        size="small"
                        label="Category"
                        value={productData.categoryId}
                        onChange={handleChange}
                        sx={{
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#e5e7eb'
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#ef4444'
                          }
                        }}
                      >
                        <MenuItem value={0} disabled>Select Category...</MenuItem>
                        {publicCategory?.categories?.response
                          ?.filter((category) => category?.name?.toLowerCase() !== "designer" &&
                            category?.name?.toLowerCase() !== "designers")
                          .map(
                            (category) =>
                              category && (
                                <MenuItem
                                  key={category.id}
                                  value={category.id}
                                  onClick={() => handleCategoryClick(category.id)}
                                >
                                  {category?.name}
                                </MenuItem>
                              )
                          )}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Sub Category</InputLabel>
                      <Select
                        name="subCategoryId"
                        size="small"
                        label="Sub Category"
                        value={productData.subCategoryId}
                        onChange={handleChange}
                        sx={{
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#e5e7eb'
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#ef4444'
                          }
                        }}
                      >
                        <MenuItem value={0} disabled>Select Sub Category...</MenuItem>
                        {publicCategory?.categories?.response
                          ?.filter((category) => category.id === selectedCategoryId)
                          .flatMap((category) =>
                            category.subCategories
                              ?.filter((subCategory) => subCategory.name.toLowerCase() !== "designer" &&
                                subCategory.name.toLowerCase() !== "designers")
                              .map((subCategory) => (
                                <MenuItem
                                  key={subCategory.id}
                                  value={subCategory.id}
                                  onClick={() => handleSubCategoryClick(subCategory.id)}
                                >
                                  {subCategory.name}
                                </MenuItem>
                              ))
                          )}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Product Category</InputLabel>
                      <Select
                        name="productCategoryId"
                        value={productData.productCategoryId}
                        onChange={handleChange}
                        label="Product Category"
                        sx={{
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#e5e7eb'
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#ef4444'
                          }
                        }}
                      >
                        <MenuItem value={0} disabled>Select Product Category...</MenuItem>
                        {publicCategory?.categories?.response?.flatMap((category) =>
                          category.subCategories
                            ?.filter(
                              (subCategory) => subCategory.id === selectedSubCategoryId
                            )
                            .flatMap((subCategory) =>
                              subCategory.productCategories?.map((productCategory) => (
                                <MenuItem
                                  key={productCategory.id}
                                  value={productCategory.id}
                                >
                                  {productCategory.name}
                                </MenuItem>
                              ))
                            )
                        )}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={6}>
                    <Autocomplete
                      freeSolo
                      disableClearable
                      options={brandOptions}
                      value={safeBrandValue}

                      // 🔥 MOST IMPORTANT (live crash fix)
                      filterOptions={(options) => options ?? []}

                      noOptionsText="No brands available"

                      onChange={(event, newValue) => {
                        setProductData((prev) => ({
                          ...prev,
                          brandName: newValue || ""
                        }));
                      }}

                      onInputChange={(event, newInputValue) => {
                        if (event) {
                          setProductData((prev) => ({
                            ...prev,
                            brandName: newInputValue || ""
                          }));
                        }
                      }}

                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Brand Name"
                          size="small"
                          fullWidth
                          placeholder="Enter or select brand"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: "#e5e7eb"
                              },
                              "&:hover fieldset": {
                                borderColor: "#ef4444"
                              }
                            }
                          }}
                        />
                      )}
                    // freeSolo // ✅ allows typing new brand
                    // options={brandOptions} // show all brand names
                    // value={productData.brandName || ""}
                    // filterOptions={(options) => options} // ✅ prevent internal crash
                    // noOptionsText="No brands found"
                    // onChange={(event, newValue) => {
                    //   setProductData((prev) => ({
                    //     ...prev,
                    //     brandName: newValue || "" // set dropdown value
                    //   }));
                    // }}
                    // onInputChange={(event, newInputValue) => {
                    //   setProductData((prev) => ({
                    //     ...prev,
                    //     brandName: newInputValue // set typed value
                    //   }));
                    // }}
                    // renderInput={(params) => (
                    //   <TextField
                    //     {...params}
                    //     label="Brand Name"
                    //     size="small"
                    //     fullWidth
                    //     sx={{
                    //       "& .MuiOutlinedInput-root": {
                    //         "& fieldset": {
                    //           borderColor: "#e5e7eb"
                    //         },
                    //         "&:hover fieldset": {
                    //           borderColor: "#ef4444"
                    //         }
                    //       }
                    //     }}
                    //   />
                    // )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={6}>
                    <TextField
                      fullWidth
                      label="GST (%)"
                      size="small"
                      name="gst"
                      value={productData.gst}
                      onChange={handleChange}
                      variant="outlined"
                      disabled={editingId && gstValue > 0}
                      inputProps={{ maxLength: 2 }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: '#e5e7eb'
                          },
                          '&:hover fieldset': {
                            borderColor: '#ef4444'
                          }
                        }
                      }}
                    />
                  </Grid>
                  {/* ✅ Return & Exchange checkboxes */}
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="returnAllowed"
                          checked={productData.returnAllowed}
                          onChange={handleCheckboxChange}
                        />
                      }
                      label="Return Allowed"
                    />
                  </Grid>
                  {/* 🔹 Checkbox for customization */}
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="customizationAllowed"
                          checked={productData.customizationAllowed}
                          onChange={handleCheckboxChange}
                        />
                      }
                      label="Customization Allowed"
                    />
                  </Grid>
                  {/* 🔹 Show price only if customization allowed */}
                  {productData.customizationAllowed && (
                    <Grid item xs={12} sm={6} md={4}>
                      <TextField
                        fullWidth
                        name="customizationPrice"
                        label="Customization Price"
                        size="small"
                        value={productData.customizationPrice}
                        onChange={handleChange}
                        variant="outlined"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            transition: "all 0.2s ease-in-out",
                            "&:hover fieldset": {
                              borderColor: "#449AEF",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#449AEF",
                              boxShadow: "0 0 0 2px rgba(239,68,68,0.2)",
                            },
                          },
                        }}
                      />
                    </Grid>
                  )}

                  <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 2, mt: 2 }}>
                    <Button
                      variant="contained"
                      type="submit"
                      disabled={adminProduct.loading}
                      sx={{
                        background: "linear-gradient(90deg, #449AEF 0%, #f87171 100%)",
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: "0.85rem",
                        borderRadius: "6px",
                        boxShadow: "0 2px 8px rgba(239,68,68,0.15)",
                        px: 2.5,
                        py: 0.8,
                        transition: "all 0.2s",
                        "&:hover": {
                          background: "linear-gradient(90deg, #f87171 0%, #449AEF 100%)",
                          boxShadow: "0 4px 16px rgba(239,68,68,0.25)",
                          transform: "scale(1.02)",
                        },
                        width: { xs: "100%", sm: "auto" },
                        textAlign: "center"
                      }}
                    >
                      {adminProduct.loading ? (
                        <>
                          <CircularProgress size={20} sx={{ mr: 1 }} />
                          Processing...
                        </>
                      ) : (editingId ? "Update Product" : "Add Product")}
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={handleCancle}
                      sx={{
                        color: "#449AEF",
                        borderColor: "#449AEF",
                        fontWeight: 600,
                        fontSize: "0.85rem",
                        borderRadius: "6px",
                        px: 2.5,
                        py: 0.8,
                        transition: "all 0.2s",
                        "&:hover": {
                          backgroundColor: "#449AEF",
                          color: "#fff",
                          borderColor: "#449AEF",
                          boxShadow: "0 2px 8px rgba(239,68,68,0.1)",
                        },
                        width: { xs: "100%", sm: "auto" },
                        textAlign: "center"
                      }}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </CardContent>
          </Card>
        </DialogContent>
      </Dialog>

      {/* Confirm Delete Dialog */}
      <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this product?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
          <Button onClick={confirmDelete} color="error" variant="contained" disabled={adminProduct.loading}>
            {adminProduct.loading ? (
              <>
                <CircularProgress size={20} sx={{ mr: 1 }} />
                Processing...
              </>
            ) : ("Confirm")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* approve empty margin and discount dialog box */}
      <Dialog open={warningOpen} onClose={() => setWarningOpen(false)}>
        <DialogTitle>Confirmation</DialogTitle>

        <DialogContent>
          ⚠️ Some variants are missing Margin or Discount.
          <br />
          Are you sure you want to continue?
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setWarningOpen(false)}>
            Cancel
          </Button>

          <Button
            color="error"
            onClick={() => {
              setWarningOpen(false);
              approveProduct(); // ✅ OK → API call
            }}
          >
            CONTINUE
          </Button>
        </DialogActions>
      </Dialog>

      {/* Common Popup */}
      <ImagePopup
        open={imageOpen}
        onClose={() => setImageOpen(false)}
        imageUrl={imageUrl}
      />

      {/* add manage product modal  */}
      <ProductManageModal
        open={openManageModal}
        onClose={() => { setOpenManageModal(false); setEditData(null); }}
        editData={editData}
      />

      {/* Modals */}
      <ColorModal open={openColorModal} onClose={handleColorClose} row={productColors} loading={adminProduct.loading} />
      <VariantModal open={openVariantModal} onClose={handleVariantClose} row={productVariants} loading={adminProduct.loading} />
      <ImageModal open={openImageModal} onClose={handleImageClose} row={productImages} loading={adminProduct.loading} />
      <ProductDetailsModal open={openDetails} onClose={handleCloseDetails} row={selectedProduct} loading={adminProduct.loading} />

    </div>
  );
};

export default Products;
